/**
 * WordPress dependencies
 */
import { createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

/**
 * External dependencies
 *
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
});

/**
 * Internal dependencies
 */
import CourseList from './components/CourseList';
import { useLocalEvents } from '@hooks';

/**
 * Main Component
 */
function Main() {
	const { data, isPending, isError } = useLocalEvents({
		group: false,
		limit: 4,
		filter: {},
	});

	return <CourseList data={data} isPending={isPending} isError={isError} />;
}

/**
 * Render block
 */
domReady(function () {
	createRoot(document.getElementById('upcoming-events')).render(
		<QueryClientProvider client={queryClient}>
			<Main />
		</QueryClientProvider>
	);
});
